import React from 'react'

type UseScrollOnRenderOptions = {
  enabled?: boolean
}

export default function useScrollOnRender({ enabled }: UseScrollOnRenderOptions) {
  const ref = React.useRef<HTMLDivElement | null>(null)

  React.useEffect(() => {
    if (!enabled) {
      return
    }

    const timeoutId = setTimeout(() => {
      if (ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)

    return () => clearTimeout(timeoutId)
  }, [enabled])

  return ref
}
